import { render, staticRenderFns } from "./ActivateTransportation.vue?vue&type=template&id=b09cbc32"
import script from "./ActivateTransportation.vue?vue&type=script&lang=js"
export * from "./ActivateTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports